module.exports = __webpack_public_path__ + "static/media/booking-cards.ca8f6d29.svg";